import React from 'react';
import './Alert.css';

export interface AlertProps {
  children: React.ReactNode;
  variant?: 'success' | 'error' | 'warning' | 'info';
  title?: string;
  onClose?: () => void;
  className?: string;
  icon?: React.ReactNode;
}

/**
 * Reusable Alert component for notifications
 */
const Alert: React.FC<AlertProps> = ({
  children,
  variant = 'info',
  title,
  onClose,
  className = '',
  icon
}) => {
  const variantClass = `common-alert--${variant}`;
  const alertClassName = className 
    ? `common-alert ${variantClass} ${className}`.trim()
    : `common-alert ${variantClass}`.trim();

  return (
    <div className={alertClassName} role="alert">
      <div className="common-alert-content">
        {icon && <div className="common-alert-icon">{icon}</div>}
        <div className="common-alert-text">
          {title && <div className="common-alert-title">{title}</div>}
          <div className="common-alert-message">{children}</div>
        </div>
      </div>
      {onClose && (
        <button 
          className="common-alert-close" 
          onClick={onClose}
          aria-label="Close alert"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Alert;

